import { render, staticRenderFns } from "./Syncs.vue?vue&type=template&id=5b583a32&scoped=true"
import script from "./Syncs.vue?vue&type=script&lang=js"
export * from "./Syncs.vue?vue&type=script&lang=js"
import style0 from "./Syncs.vue?vue&type=style&index=0&id=5b583a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b583a32",
  null
  
)

export default component.exports